import { render, staticRenderFns } from "./annualbudgetcopy.vue?vue&type=template&id=f81dc0ce&scoped=true"
import script from "./annualbudgetcopy.vue?vue&type=script&lang=js"
export * from "./annualbudgetcopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81dc0ce",
  null
  
)

export default component.exports